module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "toogle_content"
  }, [_c('form', {
    staticClass: "basic-grey"
  }, [_c('span', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.userInformation.realName))]), _vm._v(" "), _c('label', [_c('span', {
    staticClass: "leftSpan"
  }, [_vm._v("账号 :")]), _vm._v(" "), _c('span', {
    staticClass: "rightSpan",
    staticStyle: {
      "color": "#666"
    }
  }, [_vm._v(_vm._s(_vm.userInformation.userId))])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "school"
  }, [_c('span', [_vm._v("学校：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.school))])]), _vm._v(" "), _c('li', {
    staticClass: "grads"
  }, [_c('span', [_vm._v("班级：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.grads))])])])]), _vm._v(" "), _c('div', [_c('alertPW', {
    attrs: {
      "layerPW": _vm.layerPW,
      "password": _vm.userInformation.password
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-beca284e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personMsg/basicMsg.vue
// module id = 1241
// module chunks = 1